import React, { useState } from 'react'
import styled from 'styled-components'
import ChatCard from './Networking/ChatCard'
import { COLORS } from '../styles/theme'
import { LiveQuestions } from './LiveQuestions/'
import useQuestion from '../utils/questionHelper'
import useChat from '../utils/chatHelper'

const ChatContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.3);
  color: #fff;
  padding: 32px 16px;

  .divider {
    background: linear-gradient(270deg, #fe1e9a, #254dde);
    height: 2px;
  }
  h4 {
    text-align: center;
    margin: 16px;
  }
  .tabs {
    display: flex;
    justify-content: center;
    padding: 8px;

    .active {
      svg path {
        fill: #ffad2c;
      }
      small {
        color: #ffad2c;
        font-style: italic;
      }
    }
    button {
      background: transparent;
      border: none;
      svg path {
        fill: #fff;
      }
      small {
        padding: 0 4px;
        font-weight: 600;
        color: #fff;
      }
    }
  }
  .toggle-content {
    margin: 16px 0;
    color: black;
    height: 100%;
    .ques-container {
      height: 100%;
      .ques-text {
        height: 60%;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 8px;
        margin-bottom: 16px;
        font-size: 14px;
      }
    }
  }
  form {
    width: 100%;
    max-height: 100px;
    text-align: right;
    textarea {
      min-height: 45px;
      resize: none;
      outline: none;
      border: 3px solid ${COLORS.primary};
      background: white;
      border-radius: 8px;
      padding: 8px;
      width: 100%;
      &::placeholder {
        font-size: 12px;
        font-style: italic;
      }
    }

    .btn {
      font-size: 12px;
      font-weight: 600;
      color: ${COLORS.primary};
      background: transparent;
      cursor: pointer;
      svg {
        margin: 0 4px;
      }
    }
  }
  #refresh-btn {
    border: none;
    background: white;
    padding: 5px 10px;

    &:hover {
      border: solid 1px ${COLORS.primary};
    }
  }
`

export default function ChatSection({ currentUser, firebaseDb, chatDb }) {
  const {
    messages: questions,
    messagesLoading: questionsLoading,
    submitLoading: questionSubmitLoading,
    handleSubmitQuestion,
    fetchLoading: questionFetchLoading,
    scrollTrigger: questionScrollTrigger,
  } = useQuestion(firebaseDb)

  const {
    messages,
    messagesLoading,
    messagesError,
    handleSubmitMessage,
    submitLoading,
    submitError,
    handleFetchOlderMessages,
    fetchLoading,
    fetchError,
    scrollTrigger,
  } = useChat(chatDb)

  const [showChat, setShowChat] = useState(true)

  const refreshPage = () => {
    window.location.reload()
  }

  return (
    <ChatContainer>
      <div className="divider"></div>
      <div className="tabs">
        <div className={`${!showChat && 'active'}`}>
          <button>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <polygon points="0 0 24 0 24 24 0 24"></polygon>
              <path
                fill="#492777"
                d="M20,2 L4,2 C2.9,2 2,2.9 2,4 L2,22 L6,18 L20,18 C21.1,18 22,17.1 22,16 L22,4 C22,2.9 21.1,2 20,2 Z M19,16 L6,16 L4,18 L4,5 C4,4.45 4.45,4 5,4 L19,4 C19.55,4 20,4.45 20,5 L20,15 C20,15.55 19.55,16 19,16 Z"
              ></path>
            </svg>
            <small>Ask Question</small>
          </button>
        </div>
      </div>
      <div className="divider"></div>
      <div className="toggle-content">
        {!showChat ? (
          messagesError ? (
            <button id="refresh-btn" onClick={refreshPage}>
              Connection failed. Click here to refresh.
            </button>
          ) : (
            <ChatCard
              // toggleAvatar={toggleAvatar}
              messages={messages}
              messagesLoading={messagesLoading}
              handleSubmitMessage={handleSubmitMessage}
              submitLoading={submitLoading}
              handleFetchOlderMessages={handleFetchOlderMessages}
              fetchLoading={fetchLoading}
              scrollTrigger={scrollTrigger}
              currentUser={currentUser}
            />
          )
        ) : (
          <LiveQuestions
            messages={questions}
            messagesLoading={questionsLoading}
            handleSubmitMessage={handleSubmitQuestion}
            submitLoading={questionSubmitLoading}
            fetchLoading={questionFetchLoading}
            scrollTrigger={questionScrollTrigger}
            currentUser={currentUser}
          />
          // <div className="ques-container">
          //   <div className="ques-text p-3">
          //     Questions will be sent directly to the organiser.
          //   </div>
          //   <GoogleSheetForm hallName={hallName} />
          // </div>
        )}
      </div>
    </ChatContainer>
  )
}
